module.exports = __webpack_public_path__ + "img/idx-service-computer.9e8250d.webp";